<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="游戏" label-width="40">
          <auto-complete :data="gameData" v-model="gameId" placeholder="全部" @on-select="handleGame" />
        </ElFormItem>

        <ElFormItem label="媒体" label-width="40">
          <ElSelect style="width: 150px" v-model="mediaId" clearable placeholder="全部">
            <ElOption
              v-for="media in [
                { mediaName: '巨量引擎', mediaId: 10 },
                { mediaName: '腾讯', mediaId: 16 },
                { mediaName: '磁力引擎', mediaId: 32 }
              ]"
              :key="media.mediaId"
              :value="media.mediaId"
              :label="media.mediaName"
            >
            </ElOption>
          </ElSelect>
        </ElFormItem>

        <ElFormItem>
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="$emit('on-set')">新增规则</ElButton>
          <ElButton type="primary" @click="$emit('on-export')">数据导出</ElButton>
          <ElButton @click="$emit('on-config')">分包累计监控提醒配置</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import AutoComplete from '@/components/autocomplete/autocomplete'

export default {
  name: 'toutiaoGameConfigFilter',
  components: { AutoComplete },
  props: {
    gameData: {
      type: Array,
      require: true
    },
    placeholder: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      gameId: '',
      keyword: '',
      mediaId: ''
    }
  },
  watch: {
    gameId() {
      this.sendEvent()
    }
  },
  methods: {
    sendEvent() {
      const params = {
        gameId: this.gameId,
        keyword: this.keyword,
        mediaId: this.mediaId
      }
      this.$emit('on-change', params)
    },
    handleGame(meta) {
      this.gameId = meta.id
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.c-filter {
  padding-top: 10px;
}
</style>
